// ** MUI Imports
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import AuthLanguageBar from 'src/layouts/AuthLanguageBar'

// Styled component for Blank Layout component
const BlankLayoutWrapper = styled(Box)(({ theme }) => ({
  height: '100vh',

  // For V1 Blank layout pages
  '& .content-center': {
    display: 'flex',
    minHeight: '100vh',
    maxHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(5),
    overflowY: 'auto'
  },

  // For V2 Blank layout pages
  '& .content-right': {
    display: 'flex',
    minHeight: '100vh',
    overflowX: 'hidden',
    position: 'relative'
  }
}))

const BlankLayout = ({ children }) => {
  return (
    <BlankLayoutWrapper className='layout-wrapper'>
      <AuthLanguageBar />
      <Box className='app-content' sx={{ minHeight: '100vh', overflowX: 'hidden', position: 'relative', p: 10 }}>
        {children}
      </Box>
    </BlankLayoutWrapper>
  )
}

export default BlankLayout
